var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "cmp cmp-product-thumb",
      attrs: { "data-testing": _vm.item.variation.id }
    },
    [
      _c(
        "div",
        { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
        [
          _c(
            "div",
            { staticClass: "thumb-image" },
            [
              _c(
                "div",
                { staticClass: "prop-1-1" },
                [
                  _vm._l(_vm.item.tags, function(tag) {
                    return [
                      tag.id == 290
                        ? [
                            _c("div", { staticClass: "dealTag" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(tag.names.name) +
                                  "\n            "
                              )
                            ])
                          ]
                        : _vm._e()
                    ]
                  }),
                  _vm._v(" "),
                  _vm._t("item-image", [
                    _c("category-image-carousel", {
                      ref: "categoryImageCarousel",
                      attrs: {
                        "image-urls-data": _vm._f("itemImages")(
                          _vm.item.images,
                          _vm.imageUrlAccessor
                        ),
                        alt: _vm._f("itemName")(_vm.item),
                        title: _vm._f("itemName")(_vm.item),
                        "item-url": _vm._f("itemURL")(
                          _vm.item,
                          _vm.urlWithVariationId
                        ),
                        "enable-carousel":
                          _vm.$ceres.config.item.enableImageCarousel,
                        "disable-carousel-on-mobile":
                          _vm.disableCarouselOnMobile
                      }
                    })
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _vm.item.prices.rrp &&
              _vm.item.prices.rrp.price.value > 0 &&
              _vm.item.prices.rrp.price.value >
                _vm.item.prices.default.price.value
                ? [
                    _c("div", { staticClass: "item-special-icon reduced" }, [
                      _vm._v("\n          %\n        ")
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.catIcons.length > 0
                ? [
                    _c(
                      "div",
                      { staticClass: "item-characters d-flex" },
                      _vm._l(_vm.catIcons, function(varProps) {
                        return _c(
                          "div",
                          { staticClass: "character" },
                          [
                            varProps.selectionId == 1503
                              ? [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        "https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/SingleIcons/icon_schwerentflammbar.gif",
                                      title: "schwerentflammbar",
                                      alt: "schwerentflammbar",
                                      loading: "lazy"
                                    }
                                  })
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            varProps.selectionId == 1506
                              ? [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        "https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/SingleIcons/icon_aussen_innen.gif",
                                      title: "aussenanwendung",
                                      alt: "fuer aussenanwendung",
                                      loading: "lazy"
                                    }
                                  })
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      }),
                      0
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.hundredYears
                ? [
                    _c("img", {
                      staticClass: "new-badge",
                      attrs: {
                        alt: "100 years",
                        src:
                          "https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/100Jahre_Icon_" +
                          _vm.lang.toUpperCase() +
                          ".png",
                        loading: "lazy"
                      }
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.item.item.storeSpecial != null
                ? [
                    _vm.item.item.storeSpecial.id == 3
                      ? _c("img", {
                          staticClass: "new-badge",
                          attrs: {
                            alt: "topseller",
                            src:
                              "https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/topseller/Icon_Topseller_" +
                              _vm.lang.toUpperCase() +
                              ".png",
                            loading: "lazy"
                          }
                        })
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.item.item.storeSpecial != null
                ? [
                    _vm.item.item.storeSpecial &&
                    _vm.item.item.storeSpecial.id == 2
                      ? _c("img", {
                          staticClass: "new-badge",
                          attrs: {
                            alt: "neuheiten",
                            src:
                              "https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/neuheiten/icon_neu_" +
                              _vm.lang +
                              ".png",
                            loading: "lazy"
                          }
                        })
                      : _vm._e()
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _vm.item.item.storeSpecial != null
            ? _vm._t("store-special", [
                (_vm.storeSpecial ||
                  _vm.item.variation.bundleType === "bundle" ||
                  _vm.item.item.itemType === "set") &&
                _vm.item.item.storeSpecial.id !== 3
                  ? _c("item-store-special", {
                      attrs: {
                        "store-special": _vm.storeSpecial,
                        "recommended-retail-price": _vm.item.prices.rrp,
                        "variation-retail-price": _vm.item.prices.default,
                        "special-offer-price": _vm.item.prices.specialOffer,
                        "decimal-count": _vm.decimalCount,
                        "bundle-type": _vm.item.variation.bundleType,
                        "item-type": _vm.item.item.itemType
                      }
                    })
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._t("item-details", [
            _c(
              "div",
              { staticClass: "thumb-content" },
              [
                _c(
                  "a",
                  {
                    staticClass: "thumb-title",
                    class: {
                      "stretched-link":
                        _vm.$ceres.config.global.shippingCostsCategoryId == 0
                    },
                    attrs: {
                      "aria-label": _vm.item.texts.name1,
                      href: _vm._f("itemURL")(_vm.item, _vm.showVars)
                    }
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "title-shrink" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm._f("itemName")(_vm.item))
                        ),
                        _vm._l(_vm.item.groupedAttributes, function(attribute) {
                          return _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("translate")(
                                  "Ceres::Template.itemGroupedAttribute",
                                  attribute
                                )
                              )
                            )
                          ])
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.combinedPropertiesString !== ""
                      ? _c(
                          "p",
                          {
                            staticClass: "text-center mt-2",
                            staticStyle: { color: "black", "font-size": "14px" }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.combinedPropertiesString) +
                                "\n                      "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "cat-avail",
                        class:
                          "availability-" + _vm.item.variation.availability.id
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.item.variation.availability.names.name) +
                            "\n            "
                        ),
                        _vm.zulauf
                          ? [
                              _c("br"),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.zulauf) +
                                  "\n            "
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "var-count" },
                      [
                        _vm.item.item.salableVariationCount > 1
                          ? [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Woerner::Template.variationsCat"
                                      )
                                    ) + " "
                                  ),
                                  _c("i", {
                                    staticClass: "fa fa-caret-right ml-1"
                                  })
                                ])
                              ])
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "thumb-meta mt-2" },
                  [
                    _vm._t("before-prices"),
                    _vm._v(" "),
                    _c("div", { staticClass: "prices" }, [
                      _c(
                        "div",
                        {
                          staticClass: "price",
                          class: {
                            darkgreen:
                              _vm.item.prices.rrp &&
                              _vm.item.prices.rrp.price.value > 0 &&
                              _vm.item.prices.rrp.price.value >
                                _vm.item.prices.default.price.value
                          }
                        },
                        [
                          _vm.item.prices.rrp &&
                          _vm.item.prices.rrp.price.value > 0 &&
                          _vm.item.prices.rrp.price.value >
                            _vm.item.prices.default.price.value
                            ? [
                                _vm.item.prices.specialOffer
                                  ? _c("del", { staticClass: "crossprice" }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm._f("itemCrossPrice")(
                                              _vm.item.prices.default.unitPrice
                                                .formatted,
                                              true
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ])
                                  : _c("del", { staticClass: "crossprice" }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm._f("itemCrossPrice")(
                                              _vm.item.prices.rrp.unitPrice
                                                .formatted
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]),
                                _vm._v(" "),
                                _c("br", {
                                  staticClass: "d-inline-block d-md-none"
                                })
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.item.item.itemType === "set"
                            ? [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.itemSetPrice",
                                        { price: _vm.itemSetPrice }
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]
                            : _vm.itemGraduatedPriceisCheapestSorting
                            ? [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.itemFromPrice",
                                        { price: _vm.itemPriceGraduated }
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]
                            : _vm.itemGraduatedPricesalableVariationCount
                            ? [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.itemFromPrice",
                                        { price: _vm.itemPriceGraduated }
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]
                            : [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm._f("specialOffer")(
                                        _vm.item.prices.default.unitPrice
                                          .formatted,
                                        _vm.item.prices,
                                        "unitPrice",
                                        "formatted"
                                      )
                                    ) +
                                    "\n              "
                                )
                              ],
                          _vm._v(" "),
                          _vm.item.prices.default.contactClassDiscount.amount >
                          0
                            ? [
                                _c("popper", {
                                  staticClass: "ml-auto your-price",
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "handle",
                                        fn: function() {
                                          return [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-icon btn-secondary btn-sm"
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-info"
                                                })
                                              ]
                                            )
                                          ]
                                        },
                                        proxy: true
                                      },
                                      {
                                        key: "content",
                                        fn: function() {
                                          return [
                                            _c(
                                              "div",
                                              [
                                                _vm.item.prices.rrp &&
                                                _vm.item.prices.rrp.price
                                                  .value > 0 &&
                                                _vm.item.prices.rrp.price
                                                  .value >
                                                  _vm.item.prices.default.price
                                                    .value
                                                  ? [
                                                      _vm.item.prices
                                                        .specialOffer
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "crossprice"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    _vm.$translate(
                                                                      "Woerner::Template.singlePriceBisher"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                              _c("s", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "itemCrossPrice"
                                                                    )(
                                                                      _vm.item
                                                                        .prices
                                                                        .default
                                                                        .unitPrice
                                                                        .formatted,
                                                                      true
                                                                    )
                                                                  )
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "crossprice"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    _vm.$translate(
                                                                      "Woerner::Template.singlePriceBisher"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                              _c("s", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "itemCrossPrice"
                                                                    )(
                                                                      _vm.item
                                                                        .prices
                                                                        .rrp
                                                                        .unitPrice
                                                                        .formatted
                                                                    )
                                                                  )
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                    ]
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "Woerner::Template.singlePriceAktuell"
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f("currency")(
                                                          _vm.item.prices
                                                            .default.price.value
                                                        )
                                                      ) +
                                                      "\n                      "
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "Woerner::Template.singlePriceYourPrice"
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "Ceres::Template.categoryItemFromPrice",
                                                          {
                                                            price: _vm.itemPrice
                                                          }
                                                        )
                                                      ) +
                                                      "\n                      "
                                                  )
                                                ])
                                              ],
                                              2
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    2955762849
                                  )
                                })
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "text-muted small test" },
                            [
                              _vm.itemGraduatedPriceisCheapestSorting ||
                              _vm.itemGraduatedPricesalableVariationCount
                                ? [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm._f("currency")(
                                            _vm.graduatedMwstPrice
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                : [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm._f("currency")(
                                            _vm.item.prices.default.data
                                              .basePriceNet
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ],
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.itemExclVAT"
                                    )
                                  ) +
                                  "\n              "
                              )
                            ],
                            2
                          )
                        ],
                        2
                      )
                    ])
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._t("after-prices"),
                _vm._v(" "),
                _vm.item.prices.default.lowestPrice.value && _vm.hasCrossPrice
                  ? _c("div", { staticClass: "category-lowest-price small" }, [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$translate("Ceres::Template.itemLowestPrice", {
                              price:
                                _vm.item.prices.default.lowestPrice.formatted
                            })
                          )
                        }
                      })
                    ])
                  : _vm._e()
              ],
              2
            )
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }